/**
 * VM create / VM pool UI flags. Values are fixed at build time (Create React App env).
 */

function readEnvFlag(key: string, defaultValue: boolean): boolean {
  const v = process.env[key];
  if (v === undefined || v === '') return defaultValue;
  return v === 'true' || v === '1';
}

/**
 * When true, show unavailable regions and OS images as disabled with "Coming soon".
 * When false (default), only list regions and images that are actually selectable.
 */
export const SHOW_VM_COMING_SOON = readEnvFlag('REACT_APP_SHOW_VM_COMING_SOON', false);

/**
 * When true, show the GPU picker and fetch GPU pricing/availability.
 * When false (default), VM flows are CPU-only (no GPU API calls, no GPU UI).
 */
export const VM_SHOW_GPU_CONFIGURATION = readEnvFlag(
  'REACT_APP_VM_SHOW_GPU_CONFIGURATION',
  false
);
